import { jsx as _jsx } from "react/jsx-runtime";
import { SpecraCombobox } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
import { useMemo, useState } from 'react';
import { useListPursuits } from '../../hooks';
/**
 * Target picker of the Merge and Move dialogs (GRW-19): live pursuits only
 * (merged stubs are never live), searched server-side through GRW-11
 * `ListPursuits{lifecycle:'live', search}`, never the pursuit itself.
 */ export function PursuitTargetCombobox({ excludeId, value, onChange }) {
    const [search, setSearch] = useState('');
    const list = useListPursuits({
        lifecycle: 'live',
        search,
        pageSize: 20
    });
    const options = useMemo(()=>(list.data?.rows ?? []).filter((r)=>r.captureProjectId !== excludeId).map((r)=>({
                value: r.captureProjectId,
                label: r.name,
                textValue: r.name,
                description: r.customer?.label || undefined
            })), [
        list.data?.rows,
        excludeId
    ]);
    return /*#__PURE__*/ _jsx(SpecraCombobox, {
        label: "Other pursuit",
        placeholder: "Choose a pursuit",
        searchPlaceholder: "Search pursuits",
        options: options,
        value: value || undefined,
        shouldFilter: false,
        searchValue: search,
        onSearchValueChange: setSearch,
        loading: list.isLoading,
        emptyMessage: "No live pursuit matches.",
        onOptionChange: (o)=>onChange(o?.value ?? '', o?.textValue ?? ''),
        triggerProps: {
            'data-testid': Testids.pursuitSurgery.targetCombobox
        }
    });
}
